import React from 'react';
import './App.scss';
import { MainPage } from './Pages/Main/MainPage';

function App() {
  return (
    <div className="App">
      <MainPage></MainPage>
    </div>
  );
}

export default App;
